export type RenderTarget = {
	key?: string
	ctx: any
	draw: (time: number) => void
}

class RenderLoop {
	targets: RenderTarget[] = []
	interval: any
	fps: number = 60

	private lastFrameTime: number = 0

	add = (key: string, ctx: any, fn: (time: number) => void) => {
		this.targets.push({ key, ctx, draw: fn })

		if (this.targets.length > 0) {
			this.play()
		}
	}

	remove = (key: string) => {
		this.targets.forEach((target, index) => {
			if (target.key === key) {
				this.targets.splice(index, 1)
			}
		})

		if (this.targets.length === 0) {
			this.stop()
		}
	}

	play() {
		this.interval = this.requestInterval((elapsed: number) => {
			const now = Date.now()
			let i: number

			const delta = elapsed - (this.lastFrameTime || 0)
			if (this.lastFrameTime && delta < this.fps * 1.1) {
				return
			}

			this.targets.forEach((target) => {
				if (target.draw) {
					target.draw(now)
				}
			})

			this.lastFrameTime = elapsed
		})
	}

	stop() {
		if (this.interval) {
			window.cancelAnimationFrame(this.interval)
		}
		this.interval = null
	}

	requestInterval = (fn: (elapsed: number) => void, delay: number = 0) => {
		const handle = { value: null };
		const loop = (elapsed: number) => {
			handle.value = window.requestAnimationFrame(loop);
			fn(elapsed);
		}
		loop(0);

		return handle;
	}
}

export default RenderLoop
